import { render, staticRenderFns } from "./SalaryBreakdown.vue?vue&type=template&id=2ba319e2&scoped=true"
import script from "./SalaryBreakdown.vue?vue&type=script&lang=js"
export * from "./SalaryBreakdown.vue?vue&type=script&lang=js"
import style0 from "./SalaryBreakdown.vue?vue&type=style&index=0&id=2ba319e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba319e2",
  null
  
)

export default component.exports